
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.71 17.54c-.55-1.102-2.43-1.793-5.032-2.75-.495-.181-.807-.256-.947-.659a1.283 1.283 0 01.117-1.191c1.03-1.115 1.537-2.784 1.537-4.94 0-2.85-1.95-4.125-3.885-4.125-1.935 0-3.885 1.275-3.885 4.125 0 2.155.506 3.825 1.537 4.94.234.353.277.8.117 1.191-.14.403-.45.478-.947.659-2.601.957-4.482 1.65-5.032 2.75a7.927 7.927 0 00-.79 3.21c0 .207.168.375.375.375h17.25a.375.375 0 00.375-.375 7.927 7.927 0 00-.79-3.21z","fill":"#FFF","fill-rule":"nonzero"}})])
          )
        }
      }
    